// Barra de precio de dos manijas. Sincroniza las manijas con los DOS campos numéricos
// nativos del filtro de Shopify y dispara sus eventos para que Horizon recargue la
// parrilla como si el usuario los hubiera tecleado.
//
// Por qué así: los parámetros que entiende Shopify son filter.v.price.gte / .lte, y los
// pinta price-filter.liquid. Escribir en esos inputs es lo único que mantiene intacto el
// filtrado, la paginación y el Section Rendering del tema.
class ScPriceSlider extends HTMLElement {
  connectedCallback() {
    this.min = this.querySelector('.sc-pslider__manija--min');
    this.max = this.querySelector('.sc-pslider__manija--max');
    if (!this.min || !this.max) return;

    const panel = this.closest('.facets__panel') || this.parentElement;
    const campos = panel ? panel.querySelectorAll('.price-facet__input') : [];
    this.campoMin = campos[0];
    this.campoMax = campos[1];

    this.tope = Number(this.dataset.tope) || Number(this.max.max) || 0;

    this.alMover = this.alMover.bind(this);
    this.desdeCampos = this.desdeCampos.bind(this);
    this.min.addEventListener('input', this.alMover);
    this.max.addEventListener('input', this.alMover);
    // Al soltar se propaga a los campos nativos: mientras se arrastra solo se
    // repinta la barra, para no lanzar una recarga por cada píxel.
    this.min.addEventListener('change', () => this.propagar());
    this.max.addEventListener('change', () => this.propagar());

    if (this.campoMin) this.campoMin.addEventListener('change', this.desdeCampos);
    if (this.campoMax) this.campoMax.addEventListener('change', this.desdeCampos);

    this.pintar();
  }

  disconnectedCallback() {
    if (this.campoMin) this.campoMin.removeEventListener('change', this.desdeCampos);
    if (this.campoMax) this.campoMax.removeEventListener('change', this.desdeCampos);
  }

  alMover(evento) {
    // Las manijas no se cruzan.
    let a = Number(this.min.value);
    let b = Number(this.max.value);
    if (a > b) {
      if (evento.target === this.min) a = b;
      else b = a;
      this.min.value = String(a);
      this.max.value = String(b);
    }
    this.pintar();
  }

  pintar() {
    if (!this.tope) return;
    const a = (Number(this.min.value) / this.tope) * 100;
    const b = (Number(this.max.value) / this.tope) * 100;
    this.style.setProperty('--sc-pslider-desde', `${a}%`);
    this.style.setProperty('--sc-pslider-hasta', `${b}%`);
  }

  propagar() {
    const a = Number(this.min.value);
    const b = Number(this.max.value);
    // Un extremo en su tope es "sin filtro": se deja vacío para no ensuciar la URL
    // con un rango que no acota nada.
    this.escribir(this.campoMin, a > 0 ? a : '');
    this.escribir(this.campoMax, b < this.tope ? b : '');
  }

  escribir(campo, valor) {
    if (!campo || campo.value === String(valor)) return;
    campo.value = valor === '' ? '' : String(valor);
    campo.dispatchEvent(new Event('input', { bubbles: true }));
    campo.dispatchEvent(new Event('change', { bubbles: true }));
  }

  desdeCampos() {
    if (!this.tope) return;
    const a = this.campoMin && this.campoMin.value !== '' ? Number(this.campoMin.value) : 0;
    const b = this.campoMax && this.campoMax.value !== '' ? Number(this.campoMax.value) : this.tope;
    this.min.value = String(Math.max(0, Math.min(a, this.tope)));
    this.max.value = String(Math.max(0, Math.min(b, this.tope)));
    this.pintar();
  }
}

if (!customElements.get('sc-price-slider')) {
  customElements.define('sc-price-slider', ScPriceSlider);
}
